import { Controller } from "@hotwired/stimulus"
import {
  hasCookieScriptConsent,
  showCookieScriptSettings,
  subscribeToCookieScriptConsentChanges
} from "../lib/cookie_script_consent"

const YOUTUBE_CONSENT_CATEGORY = "functionality"
const CONSENT_SETTINGS_SELECTOR = ".cookie-script-settings-button"

export default class extends Controller {
  static targets = ["frame", "placeholder"]
  static values = {
    autoplay: Boolean,
    title: String,
    videoId: String
  }

  connect() {
    this.handleConsentSettingsClick = this.openConsentSettings.bind(this)
    this.element.addEventListener("click", this.handleConsentSettingsClick)

    this.updateAfterConsentChange = this.update.bind(this)
    this.unsubscribeFromConsentChanges = subscribeToCookieScriptConsentChanges(
      YOUTUBE_CONSENT_CATEGORY,
      this.updateAfterConsentChange
    )

    this.update()
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleConsentSettingsClick)
    this.unsubscribeFromConsentChanges?.()

    this.removeIframe()
  }

  update() {
    if (hasCookieScriptConsent(YOUTUBE_CONSENT_CATEGORY)) {
      this.renderIframe()
    } else {
      this.removeIframe()
    }
  }

  openConsentSettings(event) {
    if (event.cookieScriptSettingsHandled) {
      return
    }

    if (!(event.target instanceof Element)) {
      return
    }

    const settingsControl = event.target.closest(CONSENT_SETTINGS_SELECTOR)
    if (!settingsControl || !this.element.contains(settingsControl)) {
      return
    }

    event.preventDefault()
    event.cookieScriptSettingsHandled = true
    event.stopPropagation()
    showCookieScriptSettings()
  }

  renderIframe() {
    if (this.frameTarget.querySelector("iframe")) {
      return
    }

    const iframe = document.createElement("iframe")
    iframe.className = "tw:absolute tw:inset-0 tw:h-full tw:w-full"
    iframe.src = this.embedURL().toString()
    iframe.title = this.titleValue || "YouTube video"
    iframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
    iframe.allowFullscreen = true
    iframe.setAttribute("frameborder", "0")

    this.frameTarget.append(iframe)
    this.placeholderTarget.hidden = true
  }

  removeIframe() {
    const iframe = this.frameTarget.querySelector("iframe")
    if (iframe) {
      iframe.remove()
    }

    this.placeholderTarget.hidden = false
  }

  embedURL() {
    const url = new URL(`https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.videoIdValue)}`)
    url.searchParams.set("rel", "0")
    url.searchParams.set("iv_load_policy", "3")
    url.searchParams.set("modestbranding", "1")

    if (this.autoplayValue) {
      url.searchParams.set("autoplay", "1")
    }

    return url
  }
}
